<template>
  <div class="relative flex justify-end" @mouseleave="isOpen = false">
    <button aria-label="Sort by" class="text-sm h-9" @click="isOpen = true">
      <span class="flex justify-between gap-2">
        <span class="text-sm">Sort by: {{ sortLabel }}</span>
        <img src="@/assets/arrow.svg" class="w-2" height="8" width="8" alt="dropdown arrow" />
      </span>
    </button>

    <div v-show="isOpen" class="absolute w-52 z-10 p-3 top-9 right-0 bg-white shadow-lg">
      <div
        v-for="option in sortOptions"
        :key="option.value"
        class="flex cursor-pointer px-2 h-9 justify-between items-center text-sm hover:bg-gray-lighter"
        @click="selectSort(option.value)"
      >
        <span>{{ option.label }}</span>
        <img
          v-if="selectedSort === option.value"
          src="@/assets/checkmarkThin.svg"
          class="w-3"
          height="12"
          width="12"
          alt="checkmark"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { selectedSort } = defineProps<{
  selectedSort: string
}>()

const emit = defineEmits(['onSortChange'])

const isOpen = ref(false)
const sortOptions = [
  { label: 'Highest rating', value: 'score' },
  { label: 'Lowest rating', value: 'low_score' },
  { label: 'With media', value: 'with_media' },
  { label: 'Most recent', value: 'date' },
  { label: 'Verified purchase', value: 'reviewer_type' },
] as const

const sortLabel = computed(() => {
  return sortOptions.find((option) => option.value === selectedSort)?.label || 'Highest rating'
})

function selectSort(value: string) {
  isOpen.value = false
  emit('onSortChange', value)
}
</script>
